import React, { createContext } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond/dist/filepond.min.css';
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

export const imageData = createContext({});

export const Filepond = ({
    images,
    setImages,
    limit = 3,
    allowMultiple = true,
}) => {
    const server = {
        process: (file, load, error) => {
            setImages((images) => ({ ...images, [load.name]: load }));
        },
        load: {},
    };

    return (
        <div className="filepond">
            <FilePond
                files={Object.values(images)}
                allowMultiple={allowMultiple}
                allowReorder={true}
                maxFiles={3}
                name="files"
                labelIdle={`Зурагаа чирж оруулах & <span class="filepond--label-action">хайх</span>(Хязгаар: ${limit})`}
                server={server}
            />
        </div>
    );
};
